export default __webpack_public_path__ + "static/media/cuff@3x.f26234e3.webp";